var style = {"navLinkItem":"NavLinkItem-module_navLinkItem__VBkZp","disabled":"NavLinkItem-module_disabled__fbZ5e","active":"NavLinkItem-module_active__dK1Bn"};

export { style as default };
//# sourceMappingURL=NavLinkItem.module.scss.js.map
